import { render, staticRenderFns } from "./databaseManager.vue?vue&type=template&id=7b28ee39&"
import script from "./databaseManager.vue?vue&type=script&lang=js&"
export * from "./databaseManager.vue?vue&type=script&lang=js&"
import style0 from "./databaseManager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports